import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { FeatureAccessCopilotLoadAction } from '../../domains/featureAccessCopilot/actions.types';

import { FeatureAccessCopilotLifecycle } from './types';

const initialState: FeatureAccessCopilotLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<FeatureAccessCopilotLifecycle, FeatureAccessCopilotLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FEATURE_ACCESS_COPILOT.LOAD_PENDING':
      return setPending();
    case 'FEATURE_ACCESS_COPILOT.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'FEATURE_ACCESS_COPILOT.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    default:
      return state;
  }
};

export default reducer;
